import React from 'react';
import loadable from '@loadable/component';

import { bool, object } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { propTypes } from '../../util/types';

// import FallbackPage from './FallbackPage';
// import { ASSET_NAME } from './LandingPage.duck';

import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer';
import FooterContainer from '../../containers/FooterContainer/FooterContainer';
import logoNewImage from '../../assets/images/logo_new.png';
import hensImg from '../../assets/images/hens.jpeg';
// import cardImg2 from '../../assets/images/card2.jpg';
// import cardImg3 from '../../assets/images/card3.jpg';
// import farmerImg from '../../assets/images/farmer.jpeg';

import { NamedLink, Page} from '../../components';
import FallbackPage, { fallbackSections } from './FallbackPage';
import { ASSET_NAME } from './FAQPage.duck';
import { camelize } from '../../util/string';
import { getMetadata } from '../PageBuilder/PageBuilder';
import { isScrollingDisabled } from '../../ducks/ui.duck';
import OurStoryFooterImg from '../../assets/images/OurStoryFooter.png';

import css from './FAQPage.module.css';
// import { FaInstagram, FaFacebookF, FaTiktok, FaShoppingCart } from 'react-icons/fa';

export const FAQPageComponent = props => {
  const { pageAssetsData } = props;
  const { meta = {} } = pageAssetsData?.[camelize(ASSET_NAME)]?.data || {};
  const pageMetaProps = getMetadata(meta, 'Article');

  return (
    <Page {...pageMetaProps} scrollingDisabled={props.scrollingDisabled}>
      <div 
        className={css.FAQPage}
        // style={{
        //   backgroundImage: `url(${require('../../assets/images/woodBg.jpg')})`,
        // }}
      >
        <TopbarContainer />

        {/* Hero Section */}
        <div
          className={css.heroSection}
          style={{
            backgroundImage: `url(${require('../../assets/images/faqsHero.png')})`,
          }}
        >
          <div className={css.heroContainer}>
            <h1 className={css.heroTitle}>Frequently Asked Questions</h1>
            <p className={css.titleBelowText}>Whether you're here to buy fresh local food or sell what you grow or produce, we want everything to feel simple and clear.</p>
            <p className={css.contentText}>Here are answers to the most common questions we hear from shoppers and farmers.</p>
          </div>
          
        </div>

        <div 
          className={css.aboutContentWrap}
          // style={{
          //   backgroundImage: `url(${require('../../assets/images/woodBg.jpg')})`,
          // }}
        >
          {/* Content Section */}
          <div className={css.contentSection}>
            <div className={css.textBlock}>
              <h3>🛒 For Shoppers </h3>
              <div className={css.subHeading}>How do I know the products are safe?</div>
              <ul className={css.grayBoxList}>
                <li>
                  <h4>How do I know the products are safe?</h4>
                  <p>Each seller provides details about how their goods are grown, produced, or prepared.You can review descriptions, photos, and seller information beforte placing an order.</p>
                </li>
                <li>
                  <h4>How do I arrange for pickup?</h4>
                  <p>Pickup instructions are listed on the seller’s profile. After checkout, you can message the seller directly through Farmiez to confirm pickup time and details.</p>
                </li>
                <li>
                  <h4>Is delivery available?</h4>
                  <p>Most sellers currently offer local pickup only. As Farmiez grows, we may introduce additional delivery options where possible.</p>
                </li>
                <li>
                  <h4>What payment methods are accepted?</h4>
                  <p>Most payments are processed securely through Stripe using credit or debit cards. Some sellers may also offer Cash at Pickup depending on their preferences.</p>
                </li>
                <li>
                  <h4>Can I contact a seller before buying?</h4>
                  <p>Yes. You can use the built-in messaging system to ask questions before placing an order or to coordinate pickup details.</p>
                </li>
              </ul>
              
              <h3>🌱 For Sellers </h3>
              <div className={css.subHeading}>How do I know Selling on Farmiez?</div>
              <ul className={css.grayBoxList}>
                <li>
                  <h4>Can anyone sell on Farmiez?</h4>
                  <p>Yes — as long as your local laws allow it. <br/>Farmiez supports backyard growers, small producers, bakers, gardeners, and other local sellers. We encourage everyone to follow their local guidelines for selling food products.</p>
                </li>
                <li>
                  <h4>Is there a minimum or maximum order size?</h4>
                  <p>No. Sellers control their own listing size, availability, frequency, and pricing.</p>
                </li>
                <li>
                  <h4>What does it cost to sell on Farmiez?</h4>
                  <p>Selling on Farmiez starts free. As you grow, you can upgrade to plans that allow more completed sales each month.</p>
                </li>
              </ul>
              {/*<div className={css.grid2}>
                <div className={css.greenBox}>
                  <h4>🌱 Starter — Free</h4>
                  <div className={css.bulletText}>• Up to 5 Fresh Picks per month</div>
                  <div className={css.bulletText}>• Your own Farmiez seller storefront</div>
                  <div className={css.bulletText}>• Local shopper discovery</div>
                  <div className={css.bulletText}>• 0% Farmiez fees</div>
                </div>

                <div className={css.greenBox}>
                  <h4>🌿 Grower — $8.95/month</h4>
                  <div className={css.bulletText}>• Up to 50 Fresh Picks per month</div>
                  <div className={css.bulletText}>• Priority local placement</div>
                  <div className={css.bulletText}>• Trusted Grower badge</div>
                  <div className={css.bulletText}>• Farmiez marketing boosts</div>
                </div>
              </div>
              <div className={css.greenBox}>
                <h4>🌳 Plus — $14.95/month</h4>
                <div className={css.bulletText}>• Unlimited Fresh Picks</div>
                <div className={css.bulletText}>• Homepage Featured Farmer rotation</div>
                <div className={css.bulletText}>• Premium social promotion</div>
                <div className={css.bulletText}>• Custom marketing templates</div>
              </div>*/}

              <NamedLink name="SubscriptionPlansPage" className={css.customBtn}>
                <span>See full pricing and plans here</span>
              </NamedLink>

              <ul className={css.grayBoxList}>
                <li>
                  <h4>Do shoppers pay anything?</h4>
                  <p>No. Shopping on Farmiez is completely free.<br/>There are no shopper fees, subscriptions, or transaction charges.</p>
                </li>
                <li>
                  <h4>How do I get paid?</h4>
                  <p>If a shopper pays online, payouts are processed securely through Stripe and sent directly to your connected bank account.</p>
                  <p>Funds are typically released within two business days after an order is completed. Some sellers may also offer Cash at Pickup, where the buyer pays the seller directly.</p>
                </li>
                <li>
                  <h4>Can I edit or pause my listintgs?</h4>
                  <p>Absolutely. You have full control over your listings.<br/>You can update pricing, photos, availability, or pickup details anytime from your dashboard.</p>
                </li>
              </ul>

              <div className={css.contactBox}>
                <div className={css.contactText}>
                  <span>📩 If you have additional questions, you can always contact us at:</span>
                  &nbsp;
                  <span className={css.helpText}>help@farmiezmarket.com</span>
                </div>
              </div>

              <h3 className={css.greenText}>🌎 Our Sustainability Promise </h3>
              <p>At Farmiez, we're not just building a marketplace — we're growing a movement.</p>
              <p>We believe in fresh food, short supply chains, and community-powered agriculture.</p>
              <p>Every purchase through Farmiez supports local growers and producers and helps keep food dollars within the community.</p>

              <h3 className={css.greenText}>🌿 Our Marketplace Is Built Around</h3>
              <p className={css.bulletP}>• Pickup-only orders to minimize transportation waste</p>
              <p className={css.bulletP}>• Supporting local neighborhood food networks</p>
              <p className={css.bulletP}>• Small growers and producers instead of industrial agriculture</p>
              <p className={css.bulletP}>• Transparent connections between sellers and buyers</p>
              <p>As Farmiez grows, we will explore low-impact delivery options that expand access without compromising our values.</p>
              <p>When you shop on Farmiez, you’re not just feeding your family — you're strengthening your community.</p>
              <p>🌱 Let’s grow better, together.</p>
            </div>
          </div>

          {/*<img src={OurStoryFooterImg} alt="img" className={css.footerImg} />*/}
        </div>
        <FooterContainer />
      </div>
    </Page>
  );
};

FAQPageComponent.propTypes = {
  // pageAssetsData: object,
  // inProgress: bool,
  // error: propTypes.error,
};

const mapStateToProps = state => {
  const { pageAssetsData } = state.hostedAssets || {};

  return {
    pageAssetsData,
    scrollingDisabled: isScrollingDisabled(state),
  };
};

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const FAQPage = compose(connect(mapStateToProps))(FAQPageComponent);

export default FAQPage;
